import styled from 'styled-components';

export const ApiErrorsList = styled.ul`
  align-self: start;
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const ApiErrorsListItem = styled.li`
  margin-left: 0.5em;
  margin-bottom: 0.5em;

  strong {
    text-transform: capitalize;
  }
`;

export const ApiErrorsHeader = styled.h4`
  align-self: start;
  margin: 0 0 0.6em;
`;
